var _rect, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#F5F6F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15425_5788)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 21C15.8565 21 17.637 20.2625 18.9497 18.9497C20.2625 17.637 21 15.8565 21 14C21 12.1435 20.2625 10.363 18.9497 9.05025C17.637 7.7375 15.8565 7 14 7C12.1435 7 10.363 7.7375 9.05025 9.05025C7.7375 10.363 7 12.1435 7 14C7 15.8565 7.7375 17.637 9.05025 18.9497C10.363 20.2625 12.1435 21 14 21ZM22 14C22 16.1217 21.1571 18.1566 19.6569 19.6569C18.1566 21.1571 16.1217 22 14 22C11.8783 22 9.84344 21.1571 8.34315 19.6569C6.84285 18.1566 6 16.1217 6 14C6 11.8783 6.84285 9.84344 8.34315 8.34315C9.84344 6.84285 11.8783 6 14 6C16.1217 6 18.1566 6.84285 19.6569 8.34315C21.1571 9.84344 22 11.8783 22 14Z",
    fill: "#212529"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 9C13.6326 9 13.7598 9.05268 13.8536 9.14645C13.9473 9.24021 14 9.36739 14 9.5V14.71L17.248 16.566C17.3598 16.6334 17.4408 16.7419 17.4736 16.8683C17.5065 16.9946 17.4886 17.1288 17.4238 17.2422C17.3591 17.3556 17.2525 17.4391 17.127 17.4749C17.0014 17.5108 16.8669 17.4961 16.752 17.434L13.252 15.434C13.1755 15.3903 13.1119 15.3271 13.0676 15.2509C13.0234 15.1747 13 15.0881 13 15V9.5C13 9.36739 13.0527 9.24021 13.1464 9.14645C13.2402 9.05268 13.3674 9 13.5 9Z",
    fill: "#212529"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15425_5788"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClock);
export default __webpack_public_path__ + "static/media/iconClock.fd52bad6af51cd690d1cbb373dfd6141.svg";
export { ForwardRef as ReactComponent };